(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dider-free-shipping-by-country"] && !window.DesignMode) return;
  try {
    
/***
* Free shipping minimum amount dynamic
* @author: https://dider.dev
***/

const freeShippingData = document.getElementById('dider-free-shipping-dataset'),
  zone0raw = freeShippingData.dataset.zone0,
  zone0 = zone0raw.split(',').map(c => c.trim().toUpperCase()),
  zone0amount = parseFloat(freeShippingData.dataset.zone0amount),
  
  zone1raw = freeShippingData.dataset.zone1,
  zone1 = zone1raw.split(',').map(c => c.trim().toUpperCase()),
  zone1amount = parseFloat(freeShippingData.dataset.zone1amount),

  zone2raw = freeShippingData.dataset.zone2,
  zone2 = zone2raw.split(',').map(c => c.trim().toUpperCase()),
  zone2amount = parseFloat(freeShippingData.dataset.zone2amount),

  zone3raw = freeShippingData.dataset.zone3,
  zone3 = zone3raw.split(',').map(c => c.trim().toUpperCase()),
  zone3amount = parseFloat(freeShippingData.dataset.zone3amount),
  
  zone4raw = freeShippingData.dataset.zone4,
  zone4 = zone4raw.split(',').map(c => c.trim().toUpperCase()),
  zone4amount = parseFloat(freeShippingData.dataset.zone4amount),

  zone5raw = freeShippingData.dataset.zone5,
  zone5 = zone5raw.split(',').map(c => c.trim().toUpperCase()),
  zone5amount = parseFloat(freeShippingData.dataset.zone5amount);
  
const freeShippingZones = [
  { name: 'Zone 0', countries: zone0, currency: "EUR", amount: zone0amount },
  { name: 'Zone 1', countries: zone1, currency: "EUR", amount: zone1amount },
  { name: 'Zone 2', countries: zone2, currency: "EUR", amount: zone2amount },
  { name: 'Zone 3', countries: zone3, currency: "EUR", amount: zone3amount },
  { name: 'Zone 4', countries: zone4, currency: "EUR", amount: zone4amount },
  { name: 'Zone 5', countries: zone5, currency: "EUR", amount: zone5amount }
];

function findZoneByCountry(countryName) {
  return freeShippingZones.find(zone => zone.countries.includes(countryName));
}

function updateFreeShippingText() {
  const userCountry = (Shopify.country) || '',
    activeCurrency = (Shopify.currency.active) || '',
    conversionRate = (Shopify.currency.rate) || 1;

  const freeShippingElm = document.getElementById('minimum-free-shipping-amount');

  if (!freeShippingElm || !userCountry || !activeCurrency) { return; }

  const zone = findZoneByCountry(userCountry);
  if (!zone) { freeShippingElm.innerHTML = freeShippingData.innerHTML; return; }

  let amountToShow = zone.amount,
    currencyToShow = zone.currency;

  if (currencyToShow !== activeCurrency) {
    amountToShow = (zone.amount * conversionRate);
    amountToShow = Math.round(amountToShow * 100) / 100;
    if (amountToShow % 1 === 0) {
      amountToShow = amountToShow.toFixed(0);
    }
  }
  freeShippingElm.textContent = `${amountToShow} ${activeCurrency}`;
};

document.addEventListener("DOMContentLoaded", function () {
  updateFreeShippingText();
});


  } catch(e) { console.error(e); }
})();
})();
